import { Message, MessageProps } from 'semantic-ui-react';
import React, { FC }                   from 'react';

export const DangerMessage: FC<MessageProps> = ( props ) => (
	
	<Message className='fade-in' color={ 'red' } { ...props }>
		<Message.Content>{ props.children }</Message.Content>
	</Message>
);
